import React from 'react';
import { CompModel } from '../types/compensation';
import { formatDkk, formatPercent } from '../utils/format';
interface SummaryCardProps {
  model: CompModel;
}
interface Row {
  label: string;
  value: string;
  accent?: string;
  strong?: boolean;
}
export function SummaryCard({
  model
}: SummaryCardProps) {
  const rows: Row[] = [{
    label: 'Fixed salary',
    value: `${formatDkk(model.fixedMonthly)}/month`
  }, {
    label: 'Annual guaranteed cash',
    value: formatDkk(model.fixedAnnual)
  }, {
    label: 'Annual salary sacrifice',
    value: formatDkk(model.annualSacrifice)
  }, {
    label: 'Allocation',
    value: `${Math.round(model.commissionShare * 100)}% / ${Math.round(model.equityShare * 100)}%`
  }, {
    label: 'Commission opportunity',
    value: formatDkk(model.commissionOpportunity),
    accent: '#E2A03F'
  }, {
    label: 'Equity allocation value',
    value: formatDkk(model.equityValue),
    accent: '#5FB39B'
  }, {
    label: 'Indicative ownership',
    value: formatPercent(model.ownershipPercent, 2),
    accent: '#5FB39B'
  }, {
    label: 'Existing client commission',
    value: formatPercent(model.existingRate)
  }, {
    label: 'New business commission',
    value: formatPercent(model.newBusinessRate)
  }];
  return <section aria-label="Live package summary" className="rounded-card border border-line bg-ink-850 p-6 lg:p-7" data-id="element-203" data-mp="1l2yykagcbgze">
      <div className="flex items-center justify-between" data-id="element-204" data-mp="setb3fxwjdvv">
        <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-paper" data-id="element-205" data-mp="sfcu6zzag8bh">
          Live mix
        </h2>
        <span className="text-[11px] uppercase tracking-[0.14em] text-paper-dim" data-id="element-206" data-mp="xcmigcaxydxq">
          Updates as you move
        </span>
      </div>

      <dl className="mt-5 divide-y divide-line-soft" data-id="element-207" data-mp="28tcnvt7jj1qa">
        {rows.map(row => <div key={row.label} className="flex items-baseline justify-between gap-4 py-2.5" data-id="element-208" data-mp="2cuo79gztmqq1">
            <dt className="text-sm text-paper-muted" data-id="element-209" data-mp="dp4y4ttrp4ke">{row.label}</dt>
            <dd className="tnum text-sm font-medium text-paper" style={row.accent ? {
          color: row.accent
        } : undefined} data-id="element-210" data-mp="8qtoaj3h2u26">
              {row.value}
            </dd>
          </div>)}
      </dl>

      <div className="mt-5 rounded-lg border border-line bg-ink-950 p-4" data-id="element-211" data-mp="hskurq5u74x3">
        <p className="text-[11px] uppercase tracking-[0.16em] text-paper-dim" data-id="element-212" data-mp="3q6tee8qdsld4">
          Cash OTE at target
        </p>
        <p className="tnum mt-1.5 text-2xl font-semibold tracking-tight text-paper" data-id="element-213" data-mp="3m6radsx6bfuo">
          {formatDkk(model.cashOte)}
        </p>
        <p className="mt-1.5 text-xs leading-relaxed text-paper-dim" data-id="element-214" data-mp="3t1pd54eu7oh">
          Guaranteed cash + commission at 100% of target. Warrants are shown
          separately and are not part of OTE.
        </p>
      </div>
    </section>;
}